import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import { useTheme } from '@mui/material';

export const Setbacks = () => {
  const theme = useTheme();

  return (
    <VolunteerActivismIcon
      fontSize="large"
      sx={{ color: theme.palette.tertiary.main }}
    />
  );
};
